"use client";

import React from 'react';
import { cn } from '@/lib/utils';
import { DropdownMenuItem } from './DropdownMenuItem';
import { DropdownMenuDivider } from './DropdownMenuDivider';
import type { DropdownMenuProps } from './types';

export function DropdownMenu({
  items,
  className,
  dividerAfter = [],
}: DropdownMenuProps) {
  return (
    // No tooltips on dropdown rows — the visible label is enough.
    <div data-no-tooltip className={cn("flex flex-col px-1 py-[3px]", className)}>
      {items.map((item, index) => (
        <React.Fragment key={item.id || index}>
          <DropdownMenuItem {...item} />
          {dividerAfter.includes(index) && <DropdownMenuDivider />}
        </React.Fragment>
      ))}
    </div>
  );
}

